/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardRoot: {
      overflow: 'hidden',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.background.paper,
      aspectRatio: '1 / 1',
      '&:hover': {
        boxShadow: `0 0 1px ${theme.palette.secondary.main}, 0 1px 2px ${theme.palette.grey[200]}`,
      },
    },
    cardImgContainer: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      objectFit: 'cover',
    },
    cardImgContainerMd: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      objectFit: 'cover',
    },
    cardImgContainerSm: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      objectFit: 'cover',
    },
    cardImg: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  })
);

export default useStyles;
